import { AdditionalFeeSource } from '../models/AdditionalFee.model';
function isDeliveryFee(fee) {
  return fee.source === AdditionalFeeSource.SHIPPING;
}
function filterDeliveryFees(additionalFees, isDeliveryFees) {
  if (additionalFees === void 0) {
    additionalFees = [];
  }
  if (isDeliveryFees === void 0) {
    isDeliveryFees = true;
  }
  return additionalFees.filter(fee => isDeliveryFee(fee) === isDeliveryFees);
}
export function getDeliveryAdditionalFees(additionalFees) {
  if (additionalFees === void 0) {
    additionalFees = [];
  }
  return filterDeliveryFees(additionalFees);
}
export function getNonDeliveryAdditionalFees(additionalFees) {
  if (additionalFees === void 0) {
    additionalFees = [];
  }
  return filterDeliveryFees(additionalFees, false);
}
//# sourceMappingURL=deliveryAdditionalFee.utils.js.map